import styled from 'styled-components';

import { PremierText } from '@components/text';

export const Score = styled(PremierText)`
  width: fit-content;
  padding-inline: 8px;
  position: relative;
  font-size: ${({ theme }) => theme.fonts.fontSize['5xl']};
  background: linear-gradient(
    120deg,
    ${({ theme }) => theme.colors.red[500]} 20%,
    ${({ theme }) => theme.colors.purple[500]} 50%,
    ${({ theme }) => theme.colors.blue[500]} 80%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  &::before {
    content: attr(data-text);
    position: absolute;
    background: none;
    -webkit-text-fill-color: transparent;
    -webkit-text-stroke: 0.5px ${({ theme }) => theme.colors.white};
  }
`;
